export default "__VITE_ASSET__p84r3y0K__"